import React from 'react';

import './Caption.css';

export interface CaptionProps {
  children: React.ReactNode;
}

export const Caption = React.memo(function Caption({ children }: CaptionProps) {
  return <span className="caption">{children}</span>;
});
